class CTOSwatchCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (window.ctoCollection) {
      setTimeout(() => {
        this.init();
      }, 10); // small delay needed in the collection view to prevent carousel initializing before initial load
    } else {
      this.init();
    }
  }

  init() {
    this.initCarousel();
  }

  isRTL() {
    return document.documentElement.dir === 'rtl';
  }

  getCarouselContainer() {
    return this.closest('.cto-swatch-carousel');
  }

  getNavigation() {
    const carousel = this.getCarouselContainer();
    return carousel ? $(carousel).find('.js-cto-swatch-carousel-navigation') : $();
  }

  getDots() {
    const carousel = this.getCarouselContainer();
    return carousel ? $(carousel).find('.js-cto-swatch-carousel-dots') : $();
  }

  initCarousel() {
    if ($(this).hasClass('slick-initialized')) return;
    
    $(this).slick({
      prevArrow: `
        <button class="cto-gallery__arrow prev-arrow" type="button">
          <span class="screenreader">Previous</span>
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="m18.192 23.704 1.016-1.118-5.236-5.764 5.236-5.765-1.016-1.118-6.25 6.883 6.25 6.882Z" fill="#333"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button class="cto-gallery__arrow next-arrow" type="button">
          <span class="screenreader">Next</span>
          <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="m13.957 10.02-1.02 1.124 5.26 5.792-5.26 5.792 1.02 1.124 6.281-6.916-6.28-6.915Z" fill="#333"/>
          </svg>
        </button>
      `,
      dots: true,
      appendArrows: this.getNavigation(),
      appendDots: this.getDots(),
      rtl: this.isRTL(),
    });

    $(this).on('beforeChange', function(slick, currentSlide, nextSlide){
      const $videos = $(this).find('video');
      $videos.each(function(){
        this.pause();
      });
    });

    $(this).on('afterChange', function(slick, currentSlide){
      const $currentSlideVideo = $(this).find('.slick-current video')[0];
      if ($currentSlideVideo) {
        $currentSlideVideo.pause();
      }
    });
  }

  destoryCarousel() {
    $(this).slick('unslick');
  }
}

customElements.define('cto-swatch-carousel', CTOSwatchCarousel);
